import React, {useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
import TextfieldAtom from '../textfield/textfield.atom'
import email_addressStyles from './email_field.styles'

const apAtomName = {ap_atom_name: 'emailAddressAtom'}
const validationSchema = Yup.object({
  personEmail: Yup.string().matches(
    /* eslint-disable-next-line */
    /^(([a-zA-Z0-9]+([-.'!_$%&*+-\/?=^`{|}~]*)([a-zA-Z0-9])))+@(((([a-zA-Z0-9]+[a-zA-Z\-0-9]*[a-zA-Z0-9]+)|[a-zA-Z0-9])\.)+[a-zA-Z]{2,})$/,
    'Invalid email address format',
  ),
})
const StyleWrapper = styled.div`
  ${email_addressStyles}
`
const EmailAtom = function () {
  const [finalValue, setFinalValue] = useState<{personEmail: string}>()
  const {handleChange, values, errors} = useFormik({
    initialValues: {
      personEmail: '',
    },
    validationSchema,
    onSubmit: () => {
      setFinalValue(values)
    },
  })
  return (
    <StyleWrapper {...apAtomName}>
      <div className="email-textfield">
        <TextfieldAtom
          label="email address"
          type="email"
          name="personEmail"
          value={finalValue}
          error={!!errors.personEmail}
          helperText={errors.personEmail ? errors.personEmail : null}
          onChange={handleChange}
        />
      </div>
    </StyleWrapper>
  )
}
export default EmailAtom
